import { Provider } from "react-redux";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import configureStore from "./store";
import { SW_INIT, SW_UPDATE } from "./types";
import "./index.css";
import "./i18n";
import { TourProvider } from "@reactour/tour";
import { REACT_TOUR_CONFIG } from "./config";
import { createRoot } from "react-dom/client";

const store = configureStore();

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
    <Provider store={store}>
        <TourProvider {...REACT_TOUR_CONFIG}>
            <App />
        </TourProvider>
    </Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
    onSuccess: () => store.dispatch({ type: SW_INIT }),
    onUpdate: (registration) =>
        store.dispatch({ type: SW_UPDATE, payload: registration }),
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
